import { usePatientConsentStatus } from '@/hooks/patient/usePatientConsentStatus';
import { createContext } from 'react';

export interface PatientConsentData {
  isLoadingConsentStatus: boolean | undefined;
  requiresConsentSubmission: boolean | undefined;
  requireReload: boolean | undefined;
}

export const PatientConsentContext = createContext<PatientConsentData>({
  isLoadingConsentStatus: false,
  requiresConsentSubmission: false,
  requireReload: false,
});

export function PatientConsentProvider({ children }: { children: React.ReactNode }) {
  const { isLoading, data } = usePatientConsentStatus();
  const requiresConsentSubmission = Boolean(data?.requiresConsentSubmission);
  const requireReload = data?.requireReload;

  const preferencesValue = {
    isLoadingConsentStatus: isLoading,
    requiresConsentSubmission,
    requireReload,
  };

  return <PatientConsentContext.Provider value={preferencesValue}>{children}</PatientConsentContext.Provider>;
}
